export default "__VITE_ASSET__CRVwT$CD__"